module.exports = __webpack_public_path__ + "media/app/img/steam_w_64-835918f4e4549448149e73fca91e5d59.png";